import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { sanityClient, urlFor } from "../client";
import SanityBlockContent from "@sanity/block-content-to-react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { useGlobalContext } from "../Context";
import { useLayoutEffect } from "react";

export default function CoachName() {
  const [post, setPost] = useState([]);
  const [loading, setLoading] = useState(true);
  const { coachname } = useParams();
  const { setNav } = useGlobalContext();

  useLayoutEffect(() => {
    setNav(false);
    document.title = `Beyond Limits Football Academy - ${coachname}`;
  }, [setNav, coachname]);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[slug.current == "${coachname}"][0]{
          _id,
          body,
          slug{
          current
          },
          title,
            mainImage{
              asset->{
                url
              }
            },
    }
    `
      )
      .then((data) => {
        setLoading(true);
        setPost(data);
        setLoading(false);
      })
      .catch((error) => console.log(error));
  }, [coachname]);

  if (loading) {
    return (
      <section style={{ height: "700px" }}>
        <div className="container">
          <p
            style={{
              fontSize: "5rem",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            Loading....
          </p>
        </div>
      </section>
    );
  }
  const { body, slug, title, mainImage } = post;
  return (
    <section className="Players">
      <div className="container">
        <div className="row" style={{ margin: "0 0 5rem" }}>
          <div className="col-md-5">
            {mainImage && mainImage.asset && (
              <LazyLoadImage
                alt={slug}
                effect="blur"
                src={urlFor(mainImage).url()}
                className="Blog__Image--url"
                style={{ objectFit: "cover" }}
              />
            )}
          </div>
          <div className="col-md-7">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              {title && (
                <p className="Players__title" style={{ margin: 0 }}>
                  {title}
                </p>
              )}
            </div>
            <div className="Blog__Content">
              <SanityBlockContent
                blocks={body}
                projectId="qhw5zlf9"
                dataset="production"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
